export const backhairOrdering = [
  "27",
  "21",
  "33",
  "7",
  "11",
  "26",
  "25",
  "44",
  "36",
  "32",
  "39",
  "28",
  "37",
  "42",
  "1",
  "3",
  "12",
  "6",
  "9",
  "5",
  "17",
  "22",
  "14",
  "53",
  "20",
  "54",
  "43",
  "19",
  "29",
  "30",
  "46",
  "38",
  "16",
  "45",
  "34",
  "51",
  "52",
  "40",
  "48",
  "55",
  "31",
  "35",
  "50",
  "4",
  "41",
  "49",
  "47",
  "8",
  "10",
  "13",
  "18",
  "2",
  "24",
  "15",
  "23",
];
